import { isAppleMobileDevice } from '@/core/helpers/devices';
import { PaymentMethod } from '../interfaces';
import { GOOGLE_PAY, SAMSUNG_PAY } from '../constants/methods';

export const samsungPayBrowserSupported = () => !isAppleMobileDevice();
export const googlePayBrowserSupported = () => !isAppleMobileDevice();

export const unsupportedBrowserPaymentMethods = () => {
    const digitalPaymentMethods: Array<PaymentMethod> = [];

    if (!googlePayBrowserSupported()) {
        digitalPaymentMethods.push(GOOGLE_PAY);
    }

    if (!samsungPayBrowserSupported()) {
        digitalPaymentMethods.push(SAMSUNG_PAY);
    }

    return digitalPaymentMethods;
};
